import React from 'react';
import { ShieldIcon } from 'lucide-react';
export const Guarantee = () => {
  return <section className="mb-10" data-id="element-178">
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100" data-id="element-179">
        <div className="flex items-center mb-4" data-id="element-180">
          <ShieldIcon className="w-8 h-8 text-blue-600 mr-3" data-id="element-181" />
          <h2 className="text-xl font-bold text-blue-800" data-id="element-182">
            Mijn Belofte Aan Jou
          </h2>
        </div>
        <p className="mb-4 leading-relaxed" data-id="element-183">
          Ik ben zo overtuigd van de kracht van deze methode dat ik je een 30
          dagen niet-goed-geld-terug garantie geef. maakt niet uit waarom je je
          geld terug wilt.
        </p>
        <p className="mb-4 italic" data-id="element-184">
          "We garanderen een blije baas en blije hond, anders storten we liever
          het geld terug."
        </p>
        <p className="font-semibold text-blue-800" data-id="element-185">
          Dit is een 100% tevredenheidsgarantie. Je hebt letterlijk niets te
          verliezen, behalve de stress.
        </p>
      </div>
    </section>;
};